module.exports = __webpack_public_path__ + "static/img/tuzheng_02.0e7374d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_02.png
// module id = nTCK
// module chunks = 1